module.exports = __webpack_public_path__ + "files/d22d6681c6228c793a44d3436fd1dcbe.png";